import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DeviceTable from "components/device/single/ClientSideTable";
import Select from 'react-select';


export let setTimeline = () => {};
export let timeline = {};


const SingleDevice = ({ sidebarTheme, layoutTheme }) => {

    [timeline, setTimeline] = useState(new Date());

    const [deviceAttr, setDeviceAttr] = useState('');


    const [search, setSearch] = useState([]);

    const [device, setDevice] = useState(
        {
            "_id": '',
            "deviceModel": '',
            "name": '',
            "identity": '',
            "deviceCompany": '',
            "publishName": '',
            "subscribeName": '',
            "sampleName": '',
            "deviceData": []
        }
    );

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal
        fetch("/service/devices/searchdevices", {signal: signal})
        .then(res => res.json())
        .then(devices => {
            if(devices[0]) {
                if(devices[0].options) {
                    if(devices[0].options[0]){
                        setDeviceAttr(devices[0].options[0]._id)
                        setSearch(devices);
                    }
                }
            }
        })
        return function cleanup() {
            abortController.abort()
        }
    }, [])
    

    useEffect(() => {
        if(deviceAttr !== '') {
            const abortController = new AbortController();
            const signal = abortController.signal
            fetch(`/service/devices/singledevicewithattr?id=${encodeURIComponent(deviceAttr)}&time=${encodeURIComponent(timeline)}`, {signal: signal})
            .then(res => res.json())
            .then(_device => setDevice(_device))
            .catch(e => {
                throw e
            })

            return function cleanup() {
                abortController.abort()
            }
        }
    },[timeline, deviceAttr]);

    const handleDevice = (_this) => {
        if (_this._id) {
            setDeviceAttr(_this._id);
        }
    }

    const formatGroupLabel = data => (
        <div style={groupStyles}>
          <span>{data.label}</span>
          <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    );
    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
    
    const groupBadgeStyles = {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    }

    return (
        <div>
                <div className="roe-card-style">
                    <div className="roe-card-header"> 
                        <span className="hash"># </span>Cihaz
                    </div>
                    <div className="roe-card-body"> 
                        <Select
                            defaultValue={search[0] ? search[0].options[0] : []}
                            options={search}
                            onChange={handleDevice}
                            formatGroupLabel={formatGroupLabel}
                            placeholder="Cihaz Seç..."
                        />
                    </div>
            </div>
            <div>
                <DeviceTable device={device}/>
            </div>
        </div>
  );
};
const mapStateToProps = state => {
    return {
        ...state.themeChanger
    };
};

export default connect(
    mapStateToProps,
    null
)(SingleDevice);
